firebird.directive('ellipsesShorten', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(function () {
                var domElement = element[0];
                var container = domElement.getElementsByClassName('indicator-container connected')[0];
                if (container) {
                    var hiddenElementsCount = container.getElementsByClassName('ng-hide').length;
                    var allElementsCount = container.children.length;
                    return hiddenElementsCount === allElementsCount;
                }

                return true;
            }, checkAndApplyOverflowClass);

            scope.$watch(function () {
                return element[0].scrollWidth;
            }, checkAndApplyOverflowClass);

            scope.$watch(function () {
                return element[0].closest('#sidebar-left').offsetWidth;
            }, checkAndApplyOverflowClass);

            function checkAndApplyOverflowClass() {
                var domElement = element[0];
                var nameElements;

                if (domElement.classList.contains('overflow')) {
                    domElement.classList.remove('overflow');
                    nameElements = domElement.getElementsByClassName('name');
                    Array.prototype.filter.call(nameElements, function (elem) {
                        elem.style.maxWidth = '';
                    });
                }

                var indicatorVisible = false;

                var container = domElement.getElementsByClassName('indicator-container connected')[0];
                if (container) {
                    var hiddenElementsCount = container.getElementsByClassName('ng-hide').length;
                    var allElementsCount = container.children.length;
                    indicatorVisible = hiddenElementsCount !== allElementsCount;
                }

                if (indicatorVisible) {
                    var scrollWidth = domElement.scrollWidth;
                    var offsetWidth = domElement.offsetWidth;
                    if (scrollWidth > offsetWidth) {
                        if (!domElement.classList.contains('overflow')) {
                            domElement.classList.add('overflow');
                            var sidebarWidth = domElement.closest('#sidebar-left').offsetWidth || 360; //default sidebar width
                            nameElements = domElement.getElementsByClassName('name');
                            Array.prototype.filter.call(nameElements, function (elem) {
                                elem.style.maxWidth = sidebarWidth - 235 + 'px'; //arbitrary value
                            });
                        }
                    }
                }
            }
        }
    };
});
